import axios from "axios";

// Separate axios instance for client portal requests
// This does NOT include token refresh logic since client portal uses OTP-based auth
const clientAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:8000",
  withCredentials: false,
});

// Helper to deeply clean SSN and Phone fields
const deepCleanSSNPhone = (obj) => {
  if (Array.isArray(obj)) {
    obj.forEach(item => deepCleanSSNPhone(item));
  } else if (obj !== null && typeof obj === 'object') {
    Object.keys(obj).forEach(key => {
      if (['ssn_or_tin', 'phone', 'ssn', 'tin'].includes(key) && typeof obj[key] === 'string' && !obj[key].includes('*')) {
        obj[key] = obj[key].replace(/\D/g, '');
      } else {
        deepCleanSSNPhone(obj[key]);
      }
    });
  }
};

// Request interceptor - only adds client token if provided manually
// No automatic token injection from userData
clientAxiosInstance.interceptors.request.use(
  (config) => {
    // Client portal requests should manually set Authorization header
    // This interceptor doesn't automatically add tokens
    
    // Deep clean SSN and Phone fields if data exists
    if (config.data) {
      deepCleanSSNPhone(config.data);
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - NO token refresh logic
// Client portal uses temporary tokens that don't refresh
clientAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Simply reject errors without attempting token refresh
    return Promise.reject(error);
  }
);

export default clientAxiosInstance;
